import Grid from "@mui/material/Grid";
import cn from "classnames";
import { useAtom, useAtomValue } from "jotai";
import React, { ReactNode, useEffect, useState } from "react";
import { currentTheme, refreshSectionDataAtom, selectedSectionAtom } from "../../../atoms";
import SubHeader from "../NotWorkArea(Side&Head)/Header/SubHeader";
import LoadingMask from "../NotWorkArea(Side&Head)/LoadingMask";
import OutPut from "../NotWorkArea(Side&Head)/OutPut";
import SmetaSplitter from "../Tools/Splitter/SmetaSplitter";
import SmetaSplitterItem from "../Tools/Splitter/SmetaSplitterItem";
import { SmetaTabItem } from "../Tools/Tabs/PinIcons";
import { SmetaResizeElement } from "../../ComponentInterface";
import SmetaTabs from "../Tools/Tabs/SmetaTabs";
import { updateGridData } from "../Tools/Tools";
import { contentMaker } from "./FullRightSideData";

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function FullRightSide(props: any) {
  //массив с секциями
  const [sections, setSections] = useState<ReactNode[]>([]);

  const [tabIndex, setTabIndex] = useState(0);

  //переменная для ререндера при перерисовке компонента
  const sideBarSelected = useAtomValue(selectedSectionAtom);

  // переменная инициирующая обновление
  const [refreshDataAtom, setRefreshDataAtom] = useAtom(refreshSectionDataAtom);

  const theme = useAtomValue(currentTheme);

  //при смене id секции вызывается функция создания секций
  useEffect(() => {
    if (sideBarSelected.ID !== "") addTab();
  }, [sideBarSelected.ID]);

  //при вызове функции updateSection меняется объект в store что вызывает сработку этого хука
  useEffect(() => {
    if (refreshDataAtom && refreshDataAtom.refresh) {
      //отрисовка в секции по указанному id загрузки
      updateMainSection(true, refreshDataAtom.refreshId, refreshDataAtom.CommitFormOnSection).then(() => {
        setTimeout(() => {
          updateMainSection(false, refreshDataAtom.refreshId, refreshDataAtom.CommitFormOnSection);
          setRefreshDataAtom(null);
        }, 100);
      });
    }
  }, [refreshDataAtom]);

  useEffect(() => {
    document.querySelectorAll("[data-smetaresizer]").forEach((el) => {
      if (el.checkVisibility() && typeof (el as SmetaResizeElement)?.resize === "function") {
        (el as SmetaResizeElement)?.resize();
      }
    });
    updateGridData(0);
  }, [tabIndex]);

  const getTabInfo = (id?: string): number => {
    return sections.findIndex((tab: React.ReactElement<{ props: { data: { ID: string } } }>) => {
      if (sideBarSelected.ID === tab.props.data.ID || id === tab.props.data.ID) return true;
      return false;
    });
  };

  const singleTab = async (id?: string, commitFormOnSection?: unknown) => {
    return (
      <SmetaTabItem key={id || sideBarSelected.ID} data={{ ...sideBarSelected, ID: id || sideBarSelected.ID }}>
        {await contentMaker(sideBarSelected, commitFormOnSection)}
      </SmetaTabItem>
    );
  };

  //функция создает секцию если она ранее не была создана, в противном случае меняет параметр className у выбраной секции
  async function addTab() {
    const newTabIndex = getTabInfo();
    //если секции нет
    if (newTabIndex === -1) {
      //добавление выбранной  секции
      const newTab = await singleTab();
      setSections([...sections, newTab]);
      setTabIndex(sections.length);
    } else {
      setTabIndex(newTabIndex);
    }
  }

  async function updateMainSection(load: boolean, id?: string, CommitFormOnSection?: any) {
    const newTabIndex = getTabInfo(id);
    //если секции не существует то она отрисуется
    if (id && newTabIndex === -1) {
      // новый контент секции
      const newTab = await singleTab();
      // обновляем состояние секций
      setSections([...sections, newTab]);
      return;
    }
    //перерисовка секции по id
    const idToRefresh = id || sideBarSelected.ID;
    //костыль для VirtualDOM - нужно перерисовать секцию, но дом ее оставляет прежней.
    const content = load ? (
      <LoadingMask data={{ ID: idToRefresh }} />
    ) : (
      await singleTab(idToRefresh, CommitFormOnSection)
    );
    //удаляем старую секцию/загрузку и вставляем обновленную секцию
    const newSectionsArray = [...sections];
    newSectionsArray.splice(newTabIndex, 1, content);

    //обновление состояния секций
    setSections(newSectionsArray);
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      sx={{ flexGrow: 1 }}
      alignItems="stretch"
      style={{}}
      id="IDTEST"
      className={cn("backgroundColorStimate", { light: theme === "light" })}
    >
      <SmetaSplitter
        id={"OutPutTextSplitter"}
        onResizeEnd={() => updateGridData(0)}
        onCollapse={() => {
          updateGridData(0);
        }}
        onExpand={() => {
          updateGridData(0);
        }}
        orientation="horizontal"
        style={{
          width: "100%",
          height: "100%",
        }}
        primaryIndex="start"
        transitionDuration={250}
      >
        <SmetaSplitterItem>
          <Grid item style={{ width: "100%", height: "100%" }}>
            <Grid
              style={{ width: "100%", height: "100%" }}
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="stretch"
            >
              <SubHeader drawerOpen={props.drawerBool} />
              <SmetaTabs position="hidden" tabIndex={tabIndex} style={{ flex: "1 1 auto", width: "100%" }}>
                {sections}
              </SmetaTabs>
            </Grid>
          </Grid>
        </SmetaSplitterItem>
        <SmetaSplitterItem defaultCollapsed={true} size="100px">
          <div style={{ width: "100%", height: "100%" }}>
            {sideBarSelected.ID === undefined || props.isLoading ? <></> : <OutPut></OutPut>}
          </div>
        </SmetaSplitterItem>
      </SmetaSplitter>
    </Grid>
  );
}
